import React, { FC, memo } from 'react'
import styled from 'styled-components'
import { mathVars, sm } from '@ucheba/utils/helpers/styles/mixins'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { EModOrientation } from '@ucheba/utils/helpers/styles/mod.types'
import SC from '../base/PromoBlock.styles'
import { EModImgView, IPromoBlockProps } from '../types'
import { Box } from '../../Box/desktop'
import { Heading } from '../../Heading/desktop'
import { getHeadingOptions } from '../bll'
import candidatesDesktopImg from '../assets/img__candidates_desktop.png'
import schoolGirlDesktopImg from '../assets/img__school-girl_desktop.png'
import selectVuzChildrenDesktopImg from '../assets/img__select-vuz-children_desktop.png'
import computerAndBooksDesktopImg from '../assets/img__computer-and-books_desktop.png'
import consultationBoyDesktopImg from '../assets/img__consultation-boy_desktop.png'
import consultationBoyDesktopHorizontalImg from '../assets/img__consultation-boy_desktop_horizontal.png'
import { Description } from '../../Description/desktop'
import { Spacing } from '../../Spacing/desktop'

const { Block, Content: ContentSC, Image: ImageSC } = SC

const Content = styled(ContentSC)`
  ${sm.mod(EModImgView.candidates)`
    max-width: 670px;

    ${sm.breakpoint.lgAndDown`
      max-width: 575px;
    `};
  `};

  ${sm.mod(EModImgView.schoolGirl)`
    max-width: calc(100% - 288px);

    ${sm.mod(EModOrientation.vertical)`
      margin-bottom: ${mathVars(sv.spacing.medium, '+', '169px')};
    `};
  `};

  ${sm.mod(EModImgView.selectVuzChildren)`
    max-width: calc(100% - 288px);

    ${sm.mod(EModOrientation.vertical)`
      margin-bottom: ${mathVars(sv.spacing.medium, '+', '264px')};
    `};
  `};

  ${sm.mod(EModImgView.computerAndBooks)`
    max-width: calc(100% - 400px);

    ${sm.mod(EModOrientation.vertical)`
      margin-bottom: ${mathVars(sv.spacing.medium, '+', '270px')};
    `};
  `};

  ${sm.mod(EModImgView.girlWithPhone)`
    max-width: calc(100% - 311px);

    ${sm.mod(EModOrientation.vertical)`
      margin-bottom: ${mathVars(sv.spacing.medium, '+', '265px')};
    `};
  `};

  ${sm.mod(EModImgView.consultationBoy)`
    max-width: calc(100% - 277px);

    ${sm.mod(EModOrientation.vertical)`
      margin-bottom: ${mathVars(sv.spacing.medium, '+', '201px')};
    `};
  `};
`

const Image = styled(ImageSC)`
  ${sm.mod(EModImgView.candidates)`
    background-image: url(${candidatesDesktopImg});
    width: 372px;
  `};

  ${sm.mod(EModImgView.schoolGirl)`
    background-image: url(${schoolGirlDesktopImg});
    width: 276px;
  `};

  ${sm.mod(EModImgView.selectVuzChildren)`
    background-image: url(${selectVuzChildrenDesktopImg});
    width: 264px;
  `};

  ${sm.mod(EModImgView.computerAndBooks)`
    background-image: url(${computerAndBooksDesktopImg});
    width: 270px;
    margin: ${sv.spacing.xlarge} !important;
  `};

  ${sm.mod(EModImgView.girlWithPhone)`
    background-image: url('https://www.ucheba.ru/pix/upload/default/img__girl-with-phone.png');
    width: 311px;
  `};

  ${sm.mod(EModImgView.consultationBoy)`
    background-image: url(${consultationBoyDesktopImg});
    width: 268px;

    ${sm.mod(EModOrientation.horizontal)`
      background-image: url(${consultationBoyDesktopHorizontalImg});
      width: 277px;
    `};
  `};
`

/** Промо блок */
const PromoBlock: FC<IPromoBlockProps> = (props) => {
  const {
    children,
    title = '',
    subtitle = '',
    description = [],
    orientation = 'horizontal',
    imgView,
    StartIcon,
    iconBreak,
    iconSpacing,
    ...otherProps
  } = props

  const headingOptions = getHeadingOptions(title, subtitle)

  return (
    <Block as={Box} orientation={orientation} {...otherProps}>
      <Content orientation={orientation} imgView={imgView}>
        {(title || subtitle) && (
          <Heading
            {...headingOptions}
            StartIcon={StartIcon}
            iconBreak={iconBreak}
            iconSpacing={iconSpacing}
          />
        )}

        {description.length > 0 && (
          <>
            <Description description={description} />
            <Spacing spacing='large' />
          </>
        )}

        {children}
      </Content>

      <Image orientation={orientation} imgView={imgView} />
    </Block>
  )
}

export { PromoBlock }
export default memo(PromoBlock)
